
import { Input, Button, Collapse, CollapseItem } from 'element-ui';
import { CreditCardIcon } from 'vue-feather-icons';
import LoginForm from '@/pages/authenticate/components/LoginForm.vue';
import PrivacyBloc from '@/pages/authenticate/components/PrivacyBloc.vue';
import RegisterForm from '@/pages/authenticate/components/RegisterForm.vue';
import RegisterFormInfo from '@/pages/authenticate/components/RegisterFormInfo.vue';
import RegisterFormGuest from '@/pages/authenticate/components/RegisterFormGuest.vue';
import RegisterFormInfoGuest from '@/pages/authenticate/components/RegisterFormInfoGuest.vue';
import NewCompte from '@/pages/authenticate/components/NewCompte.vue';
import SlideDownUp from '@/components/transitions/SlideDownUp.vue';

export default {
  layout: 'MainLayout',
  name: 'LoginPage',
  middleware: 'auth',
  auth: 'guest',
  data() {
    return {
      activeName: '0',
      email: null,
    };
  },
  created() {
    this.$store.commit('shared/menu/toggle', {
      tabActive: 1,
      open: false,
    });
    this.email = this.$route.query?.email || null;
  },
  mounted() {
    this.isLogin();

    const route = this.$route.params.route;
    if (route === 'login') {
      this.activeName = '1';
    } else if (route === 'register') {
      this.activeName = '2';
    } else if (route === 'register-info') {
      this.activeName = '3';
    } else if (route === 'register-guest-info') {
      this.activeName = '4';
    }
  },
  methods: {
    goTo(v, $event = null) {
      this.activeName = v;
      if (v === '1') {
        this.$router.push({
          path: this.localePath({
            name: 'authenticate-route',
            params: {
              route: 'login',
            },
          }),
        });
      } else if (v === '2') {
        if ($event.query.redirect) {
          this.$router.push({
            path: this.localePath({
              name: 'authenticate-route',
              params: {
                route: 'register',
              },
              query: {
                redirect: 2,
              },
            }),
          });
        } else {
          this.$router.push({
            path: this.localePath({
              name: 'authenticate-route',
              params: {
                route: 'register',
              },
            }),
          });
        }
      } else if (v === '3') {
        this.email = $event.email;
        if ($event.route.query.redirect) {
          this.$router.push(
            this.localePath({
              name: 'authenticate-route',
              params: {
                route: 'register-info',
              },
              query: {
                redirect: 2,
              },
            })
          );
        } else {
          this.$router.push({
            path: this.localePath({
              name: 'authenticate-route',
              params: {
                route: 'register-info',
              },
              query: {
                email: $event.email,
              },
            }),
          });
        }
      } else if (v === '4') {
        this.email = $event.email;
        if ($event.route.query.redirect) {
          this.$router.push(
            this.localePath({
              name: 'authenticate-route',
              params: {
                route: 'register-guest-info',
              },
              query: {
                redirect: 2,
              },
            })
          );
        } else {
          this.$router.push({
            path: this.localePath({
              name: 'authenticate-route',
              params: {
                route: 'register-guest-info',
              },
            }),
          });
        }
      }
    },

    rdirectTo() {
      let redirectTo = { name: 'account' };
      if (this.$route.query.redirect) {
        redirectTo = { name: 'cart-delivery' };
      }
      this.$router.push({
        path: this.localePath(redirectTo),
      });
    },
    isLogin() {},
  },

  watch: {
    '$route.params'(newQueryParams) {},
  },

  components: {
    Input,
    CreditCardIcon,
    Button,
    LoginForm,
    PrivacyBloc,
    RegisterForm,
    RegisterFormInfo,
    RegisterFormGuest,
    RegisterFormInfoGuest,
    Collapse,
    CollapseItem,
    NewCompte,
    SlideDownUp,
  },
};
